import { v4 as uuid } from 'uuid';

import { MESSAGES, ROLE } from '../../../constants';
import { hasContent } from '../../../util/guards';

export interface IUserMessage {
  readonly id: string;
  readonly type: MESSAGES.USER_MESSAGE;
  readonly role: ROLE.USER;
  readonly text: string;
  readonly html?: string;
  readonly changeId?: string;
  readonly disabled: boolean;
  readonly avatar: boolean;
  readonly rm: false;
  readonly inputType?: string;
  readonly isLiveChat: boolean;
}

export const createUserMessage = (data, isLiveChat: boolean): IUserMessage => ({
  id: hasContent(data.id) ? data.id : `t-${uuid()}`,
  type: MESSAGES.USER_MESSAGE,
  role: ROLE.USER,
  text: data.text,
  html: data.html,
  changeId: data.changeId,
  disabled: false,
  avatar: true,
  rm: false,
  inputType: data.inputType,
  isLiveChat,
});
